import { useForm, Create, Form, Input, Row, Col, notification } from '@pankod/refine-antd';
import { useNavigation } from '@pankod/refine-core';
import { IRole } from 'interfaces';
import { useState } from 'react';
import { createRole } from 'services/role';

export const RoleCreate: React.FC = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { formProps, saveButtonProps, queryResult } = useForm<IRole>({
    metaData: {
      fields: ['id'],
    },
  });
  const { edit } = useNavigation();

  const onFinish = async (values: any) => {
    setIsLoading(true);
    try {
      const { name, description } = values;
      const savedRole = await createRole(name, description);
      notification.success({
        message: 'Success',
        description: 'Role created',
      });
      setTimeout(() => edit('roles', savedRole.id), 1000);
    } catch (err: any) {
      console.error(err.message);
      notification.error({
        message: 'Failed',
        description: err.message,
      });
    }
    setIsLoading(false);
  };

  return (
    <Create
      isLoading={queryResult?.isFetching}
      saveButtonProps={{
        ...saveButtonProps,
        loading: isLoading,
      }}
    >
      <Form
        {...formProps}
        layout="vertical"
        initialValues={{
          isActive: true,
        }}
        onFinish={onFinish}
      >
        <Row justify="space-around" align="middle">
          <Col xs={24} lg={12}>
            <Form.Item
              label="Role name"
              name="name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input placeholder="Enter role name" />
            </Form.Item>
            <Form.Item
              label="Description"
              name="description"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input.TextArea rows={8} placeholder="Description" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Create>
  );
};
